module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADqSURBVHgB3VJNDsFQEP6mbayEaMKKC7ARK3UCJ3ADF3ABcQBxAE4gLuACKhb+EifAxkKiYSXemGpIK0276ELiW7zJzJv55uV7H5AAtMpzi4ABM7pphfFVRxMMy73UgAtrsKsnmoYNG/7kpmMiRBWQl7N3tDcF3kNhpAjOi5RRlnAw7g/YKV16FHZkIOtNBCGvKglhj945vUj7GhLgn4ZFM4cIe8Qg8FWkMHyI6rUz2e/atsCWqN0RwsanD5gpA1MsTC6t83xcmmxFbZmbnNmYXHRj6OYo1M/kGsTx136odk7ML3EnDo1V9xtP+0tKcC787JkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/qz5.png
// module id = OYoP
// module chunks = 2